import { gql } from '@lcs/shared/api';

export const getPromptsQuery = gql`
   query GetPrompts($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      promptsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            promptId
            promptTypeName
            name
            typeId
            isActive
            isInUse
            isReusable
            createDate
            createUser {
               name
            }
            queuePeriodicAnnouncementsConnection {
               items {
                  promptId
                  extensionQueueId
                  extensionQueue {
                     extensionQueueId
                     extensionId
                     extension {
                        extensionId
                        name
                        number
                     }
                  }
               }
            }
            autoAttendantPromptsConnection {
               items {
                  promptId
                  extensionAutoAttendantId
                  extensionAutoAttendant {
                     extensionAutoAttendantId
                     extensionId
                     extension {
                        name
                        number
                     }
                  }
               }
            }
            queueMusicOnHoldConnection {
               items {
                  holdMusicPromptId
                  extensionId
                  extension {
                     name
                     number
                  }
               }
            }
            accountMusicOnHoldConnection {
               items {
                  holdMusicPromptId
               }
            }
            closedExceptionPromptsConnection {
               items {
                  promptId
                  schedule {
                     name
                  }
               }
            }
            queueCallbackPromptsConnection {
               items {
                  customCallbackPromptId
                  extension {
                     name
                     number
                  }
               }
            }
            mailboxUnavailablePromptsConnection {
               items {
                  unavailablePromptId2
                  extension {
                     name
                     number
                  }
               }
            }
            mailboxNamePromptsConnection {
               items {
                  namePromptId
                  extension {
                     name
                     number
                  }
               }
            }
            mailboxBusyPromptsConnection {
               items {
                  busyPromptId
                  extension {
                     name
                     number
                  }
               }
            }
            mailboxTemporaryUnavailablePromptsConnection {
               items {
                  temporaryUnavailablePromptId
                  extension {
                     name
                     number
                  }
               }
            }
            updateDate
            updateUser {
               name
            }
         }
      }
   }
`;
